<template>
  <div id='bd-thread-right'>
    <!-- TODO: 显示用户信息 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane :label="userInfoTip" name="info">
        <bd-info></bd-info>
      </el-tab-pane> -->
      <el-empty description="空"></el-empty>
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import BdInfo from '@/components/dashboard/main/block/children/right/BdInfo'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-thread-right',
  // components: { BdInfo },
  data () {
    return {
      activeName: 'info',
      showRTCTab: true // 为方便测试设置为true
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentMonitorThread', 'showAuthority' ]),
    username () {
      return this.userCurrentMonitorThread.visitor.username
    },
    userInfoTip () {
      return this.$t('userInfo')
    },
    cuwTip () {
      return this.$t('cuw')
    }
  },
  methods: {
    ...mapActions([ 'getCuws', 'fingerPrint', 'userTag' ]),
    handleClick (tab, event) {
      if (tab.name === 'cuw') {
        // this.getCuws()
      } else if (tab.name === 'info') {
        //
      }
    }
  },
  mounted () {
    this.getCuws()
    // 本地消息通知
    bus.$on(constants.EVENT_BUS_WEBRTC_ACCEPT, message => {
      console.log('right eventbus: ', message)
      this.showRTCTab = true
    })
  }
}
</script>

<style scoped>
#bd-thread-right {
  height: 100%;
  width: 100%;
}
.el-tabs {
  height: 100%;
  margin-left: 8px;
}
.el-tab-pane {
  padding: 0px 10px 5px 10px;
  height: calc(100% - 100px) !important;
}
.el-tabs__content {
  height: 100% !important;
  overflow-y: scroll !important;
}
</style>
